// @ts-ignore
import {createTheme} from '@material-ui/core';

// A custom theme for this app
const theme = createTheme({});

export default theme;
